export const  lunarEndpoints = {
    jobs: {
        list: {
            api: '/api/lunar/jobs',
            method: 'GET',
            parameter: false
        },
        details: {
            api: '/api/lunar/jobs/details',
            method: 'GET',
            parameter: true
        },
        add: {
            api: '/api/lunar/jobs',
            method: 'POST',
            parameter: false
        },
        edit: {
            api: '/api/lunar/jobs/update',
            method: 'POST',
            parameter: true
        },
        delete: {
            api: '/api/lunar/jobs/delete',
            method: 'POST',
            parameter: true
        }
    },
    runs: {
        list: {
            api: '/api/lunar/runs',
            method: 'GET',
            parameter: false
        },
        details: {
            api: '/api/lunar/runs/details',
            method: 'GET',
            parameter: true
        },
        status: {
            api: '/api/lunar/runs/status',
            method: 'GET',
            parameter: true
        },
        execute: {
            api: '/api/lunar/runs/execute',
            method: 'POST',
            parameter: true
        }
    }
};


// WEBPACK FOOTER //
// ./src/endpoints/lunar.endpoints.ts